function ButtonComponents(props) {
	const { number_code, code } = props;

	const copy_code = async (number_code) => {
		const selectedCode = document.getElementById(`code_${number_code}`)?.innerText ?? "";
		if (!selectedCode) {
			return;
		}

		try {
			if (navigator?.clipboard?.writeText) {
				await navigator.clipboard.writeText(selectedCode);
			} else {
				const textArea = document.createElement("textarea");
				textArea.value = selectedCode;
				textArea.style.position = "fixed";
				textArea.style.left = "-9999px";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				document.execCommand("copy");
				document.body.removeChild(textArea);
			}

			document.getElementById("popup").classList.remove("hidden");
			document.getElementById("code_popup").innerText = selectedCode;
		} catch (err) {
			console.error("Error al copiar: ", err);
		}
	};
	return (
		<>
			<p className="text-xs text-center text-balance ">
				copy code
				<span className="hidden" id={`code_${number_code}`}>
					{code}
				</span>
				<button
					type="button"
					className="underline underline-offset-2 text-sky-400 hover:text-sky-700 ml-1"
					onClick={() => copy_code(number_code)}
				>
					{" "}
					Just Here{" "}
				</button>
			</p>
		</>
	);
}

export default ButtonComponents;


